import Modal from 'react-bootstrap/Modal';
import { HotTable } from '@handsontable/react';
import React, { useState, useEffect } from 'react';
import { OverlayTrigger, Table, Tooltip } from 'react-bootstrap';
import * as XLSX from 'xlsx';

import MoreVertIcon from '@mui/icons-material/MoreVert';

import FolderOpenIcon from '@mui/icons-material/FolderOpen';

import download from 'downloadjs';

import 'handsontable/dist/handsontable.full.min.css';

import Handsontable from 'handsontable/base';
import { registerAllModules } from 'handsontable/registry';
import { Button, Accordion, AccordionDetails, AccordionSummary, Box, Chip, CircularProgress, IconButton, ListItemButton, Menu, MenuItem, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, ThemeProvider, Typography, createTheme } from '@mui/material';
import { useAuth } from 'react-oidc-context';
import SessionExpiredModal from '../../../utils/SessionExpiredModal';
import { formatDatetime } from '../../../utils/funtions';

registerAllModules();

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

function formatABN(abn) {
  if (abn == 'NOT PROVIDED') {
    return abn;
  }

  // Remove any non-digit characters in case the input is not clean
  let str = abn.replace(/\D/g, '');

  // Check if the input is exactly 11 digits, if not, handle as needed
  if (str.length !== 11) {
    console.error('Invalid ABN: ABN must be exactly 11 digits');
    return null;
  }

  // Insert spaces to format as ABN
  return str.replace(/(\d{2})(\d{3})(\d{3})(\d{3})/, '$1 $2 $3 $4');
}

export default ({ show, selectedGroup, onHide, downloadHandler, editHandler, replicateHandler, isUpdating, onBackdropOpen, onBackdropClose, onShow }) => {
  const [
    isLoading,
    setIsLoading,
  ] = useState(false);

  const [
    currentRequestId,
    setCurrentRequestId,
  ] = useState(-1);

  const [
    currentSubVersion,
    setCurrentSubVersion,
  ] = useState(-1);

  const [
    versionData,
    setVersionData,
  ] = useState([]);

  const auth = useAuth();

  const [
    expanded,
    setExpanded,
  ] = React.useState('panel1');

  const [
    sessionExpired,
    setSessionExpired,
  ] = useState(false);

  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const [
    anchorEl,
    setAnchorEl,
  ] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event, requestId, subVersion, status) => {
    if (status != 'done') {
      return;
    }
    setCurrentRequestId(requestId);
    setCurrentSubVersion(subVersion);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  async function downloadActivityStatement(clientName, clientABN, startDate, endDate) {
    onBackdropOpen();

    let period = `${new Date(startDate).toLocaleString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })} to ${new Date(endDate).toLocaleString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })}`;

    try {
      let response = await fetch(`${window.origin}/api/reporter/reports`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.user?.access_token}`,
        },
        body: JSON.stringify({
          startDate: startDate,
          endDate: endDate,
          clients: [
            {
              abn: clientABN,
              client_name: clientName,
            },
          ],
        }),
      });
      const json_resp = await response.json();

      console.log(json_resp);

      if (response.status === 403) {
        setSessionExpired(true);
        throw new Error('Session expired');
      }

      response = await fetch(`${window.location.origin}/download/reports`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth.user?.access_token}`,
          },
          body: JSON.stringify({
            ...json_resp,
            request: {
              startDate: startDate,
              endDate: endDate,
              clients: [{ abn: clientABN, client_name: clientName }],
            },
          }),
        });

      const blob_response = await response.blob();

      await download(blob_response, `ActivityStatements_${clientName}_${period}.zip`);

      onBackdropClose();
    } catch (e) {

    }
  }

  function reload() {
    fetch(`${window.origin}/api/creator/request-groups/${selectedGroup.clientId}/details/${selectedGroup.startDate}/${selectedGroup.endDate}`, {
      headers: {
        'Authorization': `Bearer ${auth.user?.access_token}`,
        'Cache-Control': 'no-cache',
        'If-None-Match': '0',
      },
    })
      .then((response) => {
        if (response.status === 403) {
          setSessionExpired(true);
          throw new Error('Session expired');
        } else {
          return response.json();
        }
      })
      .then((data) => {
        console.log(data);
        setVersionData(data);
        if (selectedGroup.version == -1) {
          setExpanded(data[0].version);
        } else {
          setExpanded(selectedGroup.version);
        }
        // onBackdropClose()
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        // onBackdropClose()
        setIsLoading(false);
      })
      .finally(() => {

      });
  }

  useEffect(() => {
    console.log(selectedGroup);

    let timer;

    if (selectedGroup.clientId != -1 && !isUpdating && show) {
      timer = setInterval(() => {
        reload();
      }, 3000);
    }

    return () => clearInterval(timer);
  }, [
    selectedGroup,
    isUpdating,
    show,
  ]);

  useEffect(() => {
    if (show) {
      setIsLoading(true);
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="modal-70w"
      aria-labelledby="example-custom-modal-styling-title"
    >

      <Modal.Body style={{ textAlign: 'center', padding: '0 2vw' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
          <div>
            <FolderOpenIcon style={{ margin: '0.9vw', marginTop: '1.5vw', fontSize: '4vw', color: '#1c6c6c' }} />
          </div>
          <div style={{ flex: 1, padding: '0.5vw', paddingLeft: '0' }}>
            <p style={{ fontSize: '1.1vw', margin: 0, lineHeight: '1.5vw', fontWeight: '500', color: 'rgb(0, 15, 30, 0.9)', marginBottom: '0.5vw' }}>{`${new Date(selectedGroup.startDate).toLocaleString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })} to ${new Date(selectedGroup.endDate).toLocaleString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })}`}</p>
            {/* <p style={{fontSize: '0.75vw', lineHeight: '1.5vw', margin: 0, fontWeight: '400', color: 'rgb(0, 15, 30, 0.7)'}}>{formatABN(selectedGroup.clientAbn)}</p> */}
            <p style={{ fontSize: '0.75vw', lineHeight: '1.5vw', margin: 0, fontWeight: '500', color: 'rgb(0, 15, 30, 0.8)' }}>{selectedGroup.clientName}</p>
          </div>
        </div>

        <div style={{ margin: '1.3vw' }}>
          <div>

            <div style={{ borderRadius: '1vw', margin: '0', overflow: 'hidden', backgroundColor: 'rgb(255, 255, 255, 0.8)' }}>
              <ListItemButton style={{ backgroundColor: 'rgb(0, 0, 0, .03)' }}>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%', textAlign: 'left' }}>
                  <div style={{ flex: 1, fontSize: '0.8vw', fontWeight: '500', marginLeft: '1vw' }}>Version</div>
                  <div style={{ flex: 2, fontSize: '0.8vw', fontWeight: '500' }}>Created At</div>
                  <div style={{ flex: 1, fontSize: '0.8vw', fontWeight: '500' }}>Status</div>
                  {/* <div style={{fontSize: '0.8vw', fontWeight: '500', width: '2vw'}}>{``}</div> */}
                </div>
              </ListItemButton>

              <Box
                style={{ width: '100%' }}
                sx={{ width: '100%', bgcolor: 'rgb(0, 0, 0, 0)', overflowY: 'scroll' }}
              >

                { isLoading && (
                  <div style={{ width: '100%', textAlign: 'center', margin: '5vh 0' }}>
                    <CircularProgress color="inherit" />
                  </div>
                ) }
                { !isLoading

                  && (
                    <>

                      {versionData.map((version, index) => (
                        <ListItemButton style={{ width: '100%' }} onClick={(e) => { if (version.status == 'fail') { return; };handleClick(e, version.request_id, version.workpapers[0].subVersion, version.status); }} id={version.requestid + version.version + 'button'}>
                          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', padding: '0.2vw 0', color: version.status == 'fail' ? 'rgb(0, 0, 0, 0.3)' : 'inherit' }}>
                            <div style={{ flex: 1, fontSize: '0.8vw', marginLeft: '1vw' }}>{`${version.version}`}</div>
                            <div style={{ flex: 2, fontSize: '0.8vw' }}>{formatDatetime(version.created_on)}</div>

                            <div style={{ flex: 1, fontSize: '0.8vw' }}>
                              <OverlayTrigger
                                key="top-submit"
                                placement="top"
                                overlay={(
                                  <Tooltip id="tooltip-submit">
                                    {version.status_details && (version.status_details.includes('is ready') || version.status_details.includes('Name not found')) ? version.status_details : 'Unknown error'}
                                  </Tooltip>
                                )}
                              >
                                <span style={{ cursor: 'help' }}>{`${version.status == 'done' ? 'Completed' : version.status == 'ctlreq' ? 'Queued' : version.status == 'processing' ? 'Generating' : 'Failed'}`}</span>

                              </OverlayTrigger>

                            </div>
                            {/* <div style={{fontSize: '0.6vw', width: '2vw'}}>
                                                        <IconButton style={{height: '0.8vw', fontSize: '0.8vw', width:  '0.8vw'}} aria-label="delete" >
                                                            <MoreVertIcon style={{height: '1.5vw', width:  '1.5vw'}} />
                                                        </IconButton>
                                                    </div> */}
                          </div>
                        </ListItemButton>
                      ))}
                    </>
                  )}

              </Box>
            </div>

            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': currentRequestId + currentSubVersion + 'button',
              }}
            >
              {/* { currentSubVersion != 0 && <MenuItem onClick={() => {editHandler(currentRequestId, currentSubVersion); handleClose()}}>Edit</MenuItem>} */}
              {/* { currentSubVersion == 0 && <MenuItem onClick={() => {editHandler(currentRequestId, currentSubVersion); handleClose()}}>View</MenuItem>} */}
              {/* <MenuItem onClick={() => {replicateHandler(currentRequestId, currentSubVersion); handleClose()}}>Replicate</MenuItem> */}
              {/* <MenuItem onClick={async () => {await downloadActivityStatement(selectedGroup.clientName, selectedGroup.clientAbn, selectedGroup.startDate, selectedGroup.endDate); handleClose()}}>Download Activity Statement</MenuItem> */}
              <MenuItem onClick={() => { downloadHandler(currentRequestId, selectedGroup.clientName, `${new Date(selectedGroup.startDate).toLocaleString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })} to ${new Date(selectedGroup.endDate).toLocaleString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })}`); handleClose(); }}>Download Workpaper</MenuItem>
            </Menu>

          </div>
        </div>

        <Button
          onClick={onHide}
          variant="outlined"
          style={{
            borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '2vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.05vw',
            width: '30%', marginTop: '1vw' }}
        >
          Close
        </Button>

      </Modal.Body>
      <SessionExpiredModal show={sessionExpired} />
    </Modal>
  );
};

